export const AvailableLanguages = [
  { lang: 'hr', name: 'Hrvatski' },
  { lang: 'en', name: 'English' }
];
